import { AxiosResponse } from 'axios';
import { appContextPost } from './httpCommon/appAxios.service';
import { Quote } from '../types/interfaces/shipments.interfaces';
import { SHIPMENT_ENDPOINTS } from '../constants/apiEndpoints';

export const getShippingQuoteForOrder = (payload: {}): Promise<AxiosResponse<Quote, any>> => {
  return appContextPost(SHIPMENT_ENDPOINTS.QUOTE, payload);
};

export const placeShippingOrder = (bulkOrderId: number, accountId: number, payload: {}): Promise<AxiosResponse<any, any>> => {
  const params = { bulkOrderId, accountId };
  return appContextPost(SHIPMENT_ENDPOINTS.ORDERS, payload, params);
};

export const generateShippingLabel = (bulkOrderId: number): Promise<AxiosResponse<any, any>> => {
  return appContextPost(SHIPMENT_ENDPOINTS.CREATE_LABEL, {}, { bulkOrderId });
};
